import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Icon } from '@iconify/react';
// material
import { styled } from '@mui/material/styles';
import { Box, MenuItem, Typography, ListItem, Avatar, IconButton, Stack } from '@mui/material';
// components
import { useDispatch, useSelector } from 'react-redux';
import MenuPopover from '../../components/MenuPopover';
import { groupsActions, reportTripsActions, summaryAction, summaryPilotAction } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectGroupSelectedId, selectGroupsArray, selectSession } from '../../createSelectorUtils';
//

// ----------------------------------------------------------------------

const AccountStyle = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200]
}));

// ----------------------------------------------------------------------
const status = (status) => {
  switch (status) {
    case 0:
      return 'Admin';
    case 1:
      return 'Gestionnaire';
    case 2:
      return 'Instructeur';
    case 3:
      return 'Pilote+';
    case 4:
      return 'Pilote';
    default:
      return '';
  }
};
export default function DashboardClubChoice() {
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const t = useTranslation();
  const navigate = useNavigate();

  const groupId = useSelector(selectGroupSelectedId);
  const permissions = useSelector(selectSession).permission || [];
  const permission = permissions.find((item) => item.groupid === groupId) || {};

  const groups = useSelector(selectGroupsArray);
  const group = groups.find((item) => item.id === groupId) || {};

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleChoiceGroup = (id) => {
    dispatch(groupsActions.select(id));
    if (window.location.pathname === '/flight/review') {
      navigate('/flight/list');
    } else if (
      window.location.pathname === '/device/edit' ||
      window.location.pathname === '/device/add'
    ) {
      navigate('/device');
    } else if (
      window.location.pathname === '/user/edit' ||
      window.location.pathname === '/user/add'
    ) {
      navigate('/user');
    }
    dispatch(summaryAction.update([]));
    dispatch(summaryPilotAction.update([]));
    dispatch(summaryPilotAction.updateResult([]));
    dispatch(reportTripsActions.update([]));
    window.localStorage.clear();
    window.localStorage.setItem('groupId', id);

    handleClose();
  };

  return (
    <>
      <Box sx={{ px: 2.5, py: 2 }} ref={anchorRef}>
        <AccountStyle onClick={handleOpen} button disabled={groups.length === 0}>
          <Avatar>
            <Icon icon="ic:baseline-account-balance" />
          </Avatar>
          <Box sx={{ ml: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Stack direction="column">
                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                  {groupId === 0 ? t('DB_Personnel_account') : group.name}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {status(permission.status)}
                </Typography>
              </Stack>
              <IconButton>
                <Icon icon="ic:baseline-code" rotate={1} width={20} height={20} />
              </IconButton>
            </Stack>
          </Box>
        </AccountStyle>
      </Box>
      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        {groups.map((group) => (
          <MenuItem
            key={group.id}
            onClick={() => handleChoiceGroup(group.id)}
            value={group.id}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {group.name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {permissions.map((item) => item.groupid).includes(group.id)
                  ? status(permissions.find((item) => item.groupid === group.id).status)
                  : ''}
              </Typography>
            </Box>
          </MenuItem>
        ))}
        <MenuItem
          key="personnel"
          onClick={() => handleChoiceGroup(0)}
          value={0}
          sx={{ typography: 'body2', py: 1, px: 2.5 }}
        >
          <Box sx={{ ml: 2 }}>
            <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
              {t('DB_Personnel_account')}
            </Typography>
          </Box>
        </MenuItem>
      </MenuPopover>
    </>
  );
}
